import { IErrorHistoryItem } from "../../../domain/model";

export class HandleHistoryItemsAddError {
  constructor(public entities: Array<IErrorHistoryItem>) {}
}